import { TableCellType } from "../../components/risa-custom-table/table";
import type { TableHeader } from "../../data-model/customTableModel";

/**
 * Column configuration for the Patient Eligibility Mapping worklist.
 */
export const TABLE_HEADERS: TableHeader[] = [
  {
    label: "Patient Details",
    key: "patientDetails",
    order: 1,
    width: 12,
    sortable: true,
    sortField: "patient_name",
    type: TableCellType.MULTILINE_CELL_WITH_LEFT_BORDER,
  },
  {
    label: "Diagnosis",
    key: "diagnosis",
    order: 2,
    width: 12,
    sortable: true,
    sortField: "diagnosis",
    type: TableCellType.DIAGNOSIS_WITH_OVERFLOW,
  },
  {
    label: "Stage",
    key: "stage",
    order: 3,
    width: 6,
    sortable: true,
    sortField: "stage",
    type: TableCellType.STAGE_WITH_OVERFLOW,
  },
  {
    label: "Principal MD",
    key: "principalMd",
    order: 4,
    width: 12,
    sortable: true,
    sortField: "principal_md",
    type: TableCellType.STRING,
  },
  {
    label: "Additional Trials",
    key: "additionalTrials",
    order: 5,
    width: 12,
    sortable: false,
    type: TableCellType.CUSTOM_RENDER,
  },
  {
    label: "Next Visit",
    key: "nextVisit",
    order: 6,
    width: 9,
    sortable: true,
    sortField: "next_md_visit",
    type: TableCellType.STRING,
  },
  {
    label: "Eligibility Tier",
    key: "eligibilityTier",
    order: 7,
    width: 11,
    sortable: true,
    sortField: "eligibility_tier",
    type: TableCellType.TAG_CELL,
  },
  {
    label: "Eligibility Status",
    key: "eligibilityStatus",
    order: 8,
    width: 9,
    sortable: true,
    sortField: "eligibility_status",
    type: TableCellType.TAG_CELL,
  },
  {
    label: "Patient Status",
    key: "patientStatus",
    order: 9,
    width: 10,
    sortable: true,
    sortField: "patient_status",
    subKey: "sortValue",
    type: TableCellType.CUSTOM_RENDER,
  },
  {
    label: "Action Items",
    key: "actionItems",
    order: 10,
    width: 7,
    sortable: false,
    type: TableCellType.ELIGIBILITY_ACTION_ITEMS,
  },
];
